
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { SITE_URL } from '../lib/site';
// Each embeddable variant of the /widget page, with the iframe size that fits it.
const VARIANTS = [
    { key: 'card', width: 320, height: 190 },
    { key: 'compact', width: 260, height: 150 },
    { key: 'line', width: 420, height: 64 }
];
function VariantBlock({ variant, widgetPath, widgetUrl }) {
    const { t } = useTranslation('embed');
    const [copied, setCopied] = useState(false);
    const { key, width, height } = variant;
    const src = key === 'card' ? widgetUrl : `${widgetUrl}?variant=${key}`;
    const previewSrc = key === 'card' ? widgetPath : `${widgetPath}?variant=${key}`;
    const snippet = `<iframe src="${src}" width="${width}" height="${height}" style="border:0" title="CPH security wait time" loading="lazy"></iframe>`;
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(snippet);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
        catch {
            // clipboard unavailable; the code is selectable in the <pre> below
        }
    };
    return (<div className="mt-8 border-t border-gray-100 pt-6">
            <h2 className="text-xl font-semibold">{t(`variant_${key}`)}</h2>
            <p className="mt-1 text-sm text-gray-600">
                {t(`variant_${key}_desc`)}
            </p>

            <div className="mt-3 border border-gray-200 rounded p-2 inline-block">
                <iframe src={previewSrc} width={width} height={height} style={{ border: 0 }} title={`CPH security wait time (${key})`} loading="lazy"/>
            </div>

            <pre className="mt-3 bg-gray-100 rounded p-3 overflow-x-auto text-sm">
                <code>{snippet}</code>
            </pre>
            <button onClick={copy} className="mt-2 px-4 py-2 rounded bg-[var(--primary)] text-white text-sm">
                {copied ? t('copied') : t('copy')}
            </button>
        </div>);
}
function Embed() {
    const { t, lang } = useTranslation('embed');
    const widgetPath = lang === 'en' ? '/en/widget' : '/widget';
    const widgetUrl = `${SITE_URL}${widgetPath}`;
    return (<div className="bg-white p-4 sm:p-6 my-auto rounded max-w-3xl mx-auto text-gray-800">
            <Head>
                <title>{t('meta_title')}</title>
                <meta name="description" content={t('meta_description')}/>
                <meta name="robots" content="all"/>
                <meta property="og:title" content={t('meta_title')}/>
                <meta property="og:description" content={t('meta_description')}/>
            </Head>

            <h1 className="text-2xl sm:text-3xl font-bold">{t('page_title')}</h1>
            <p className="mt-3 text-gray-600">{t('intro')}</p>
            <p className="mt-2 text-gray-600">{t('variants_intro')}</p>

            {VARIANTS.map((variant) => (<VariantBlock key={variant.key} variant={variant} widgetPath={widgetPath} widgetUrl={widgetUrl}/>))}

            <p className="mt-8 text-sm text-gray-600">{t('attribution_note')}</p>
        </div>);
}
export default Embed;

    async function __Next_Translate__getStaticProps__1a1723ec61c__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/embed',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec61c__ as getStaticProps }
  